var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 36.25L24.5 27.25M15.5 27.25H15.5202M24.4798 36.25H24.5M20 47.5C24.7739 47.5 29.3523 45.6036 32.7279 42.2279C36.1036 38.8523 38 34.2739 38 29.5C38 16 20 2.5 20 2.5C19.127 8.09575 18.272 11.0995 15.5 16C12.8 14.7512 12.125 13.75 11 10.9375C6.5 16 2 22.75 2 29.5C2 34.2739 3.89642 38.8523 7.27208 42.2279C10.6477 45.6036 15.2261 47.5 20 47.5Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout4);
export default __webpack_public_path__ + "static/media/about4.0040b7276175d3d8e5ce0fb6548bfb7c.svg";
export { ForwardRef as ReactComponent };